import InputFile from './InputFile';

export default InputFile;
export { getBase64, validateFile } from './fileUtils';
